import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MydocmaTreeModule} from '@mydocma/component-library/src/lib/tree';
import { StructureTreeComponent } from './structure-tree/structure-tree.component';
import { AppContainerModule } from '@mydocma/app-container';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '@mydocma/component-library';
import { MydocmaHighlightModule } from '@mydocma/component-library/src/lib/highlight';
import { StructureLeftPaneComponent } from './structure-left-pane.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';


@NgModule({
  declarations: [
    StructureLeftPaneComponent,
    StructureTreeComponent
  ],
  imports: [
    CommonModule,
    MydocmaTreeModule,
    AppContainerModule,
    TranslateModule,
    LoaderModule,
    MydocmaHighlightModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  providers: [
  ],
  exports: [
    StructureLeftPaneComponent,
    StructureTreeComponent
  ]
})
export class StructureCommonModule { }
